// src/pages/Login.js
import React, { useState } from 'react';
import { signInWithGoogle } from '../services/auth';
import './Login.css';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleGoogleLogin = async () => {
    setLoading(true);
    setError('');
    
    try {
      await signInWithGoogle();
    } catch (error) {
      setError('登入失敗，請再試一次');
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      {/* 背景動畫元素 */}
      <div className="background-animation">
        <div className="floating-element plane">✈️</div>
        <div className="floating-element luggage">🧳</div>
        <div className="floating-element map">🗺️</div>
        <div className="floating-element camera">📷</div>
        <div className="floating-element compass">🧭</div>
        <div className="floating-element mountain">🏔️</div>
      </div>

      <div className="login-content">
        <div className="login-hero">
          <div className="hero-icon">
            <span className="main-icon">🧳</span>
            <div className="icon-decoration">
              <span className="deco-icon">✈️</span>
              <span className="deco-icon">🗺️</span>
              <span className="deco-icon">📍</span>
            </div>
          </div>
          
          <h1 className="hero-title">
            <span className="title-main">TripManager</span>
            <span className="title-subtitle">智能旅遊規劃平台</span>
          </h1>
          
          <p className="hero-description">
            規劃你的完美旅程，分享你的精彩回憶
          </p>
        </div>

        <div className="login-card">
          {error && (
            <div className="error-message">
              <span className="error-icon">⚠️</span>
              {error}
            </div>
          )}
          
          <button 
            onClick={handleGoogleLogin}
            disabled={loading}
            className="google-login-btn"
          >
            {loading ? (
              <div className="loading-content">
                <div className="loading-spinner"></div>
                <span>登入中...</span>
              </div>
            ) : (
              <div className="login-btn-content">
                <img 
                  src="https://developers.google.com/identity/images/g-logo.png" 
                  alt="Google"
                  className="google-icon"
                />
                <span>使用 Google 登入</span>
                <div className="btn-shine"></div>
              </div>
            )}
          </button>
          
          <div className="login-features">
            <h3>✨ 為什麼選擇 TripManager？</h3>
            <div className="features-grid">
              <div className="feature-item">
                <span className="feature-icon">📅</span>
                <div className="feature-text">
                  <h4>智能規劃</h4>
                  <p>輕鬆建立和管理旅行行程</p>
                </div>
              </div>
              
              <div className="feature-item">
                <span className="feature-icon">⭐</span>
                <div className="feature-text">
                  <h4>評分記錄</h4>
                  <p>記錄景點評分和旅行心得</p>
                </div>
              </div>
              
              <div className="feature-item">
                <span className="feature-icon">💰</span>
                <div className="feature-text">
                  <h4>費用管理</h4>
                  <p>詳細的費用分類和統計</p>
                </div>
              </div>
              
              <div className="feature-item">
                <span className="feature-icon">🌐</span>
                <div className="feature-text">
                  <h4>社群分享</h4>
                  <p>與其他旅行者分享精彩行程</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="login-footer">
        <p>🎯 開始你的旅行規劃之旅</p>
      </div>
    </div>
  );
};

export default Login;